module.exports = __webpack_public_path__ + "static/img/heroimage_seclesson_small.11de338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_seclesson_small.png
// module id = 365
// module chunks = 1